import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { InterviewButton } from '../../../containers/Buttons';

const PatientInterviewCard = () => (
  <Card>
    <CardBody>
      <InterviewButton />
    </CardBody>
  </Card>
);

export default PatientInterviewCard;
